<template>
    <div class="container flex-wrap flex-line">
      <div style="flex-shrink:0;width:140px;height:100%;border-right:1px solid var(--border);overflow-y:auto;"
      >

         <BaseMenu
            :menus="menus"
            :actived="actived"
            @on-click="handleOpen"
        >
        </BaseMenu>
      </div>
      <div style="width:calc(100% - 140px);height:100%;position:relative;">

          <router-view></router-view>
      </div>
    </div>
  </template>

<script>
import {mapGetters} from 'vuex';
import responsableMixin from '@/mixins/responsable';
export default {
  routerOption: {
    as_frame: true,
  },
  mixins: [responsableMixin],
  mounted() {

  },
  computed: {
    ...mapGetters('cm', ['permission']),
    sm() {
      return this.w < 1200;
    },
    menus() {
      const items = [
        {
          name: '客户征信管理',
          key: 'info',
          icon: 'md-speedometer',
        },
        {
          name: '客户履约评价',
          key: 'eval',
          icon: 'md-speedometer',
        },
        {
          name: '客户年度授信',
          key: 'year_credit',
          icon: 'md-speedometer',
        },
        {
          name: '应收账款分析',
          key: 'transfer',
          icon: 'md-speedometer',
        },
        {
          name: '逾期应收账款',
          key: 'over_transfer',
          icon: 'md-speedometer',
        }, {
          name: '客户问题跟踪',
          key: 'question',
          icon: 'md-speedometer',
        }, {
          name: '违法追究记录',
          key: 'law_record',
          icon: 'md-speedometer',
        },

        {
          name: '商账追收记录',
          key: 'collection_records',
          icon: 'md-speedometer',
        },
        {
          name: '风险评估',
          key: 'customer-risk-assessment',
          icon: 'md-alert',
        },
        {
          name: '售后跟踪',
          key: 'after-sales-tracking',
          icon: 'md-chatbubbles',
        },
      ];
      return items;
    },
    actived() {
      return this.$route.path.slice(this.$route.path.lastIndexOf('/')+1);
    },

  }, methods: {
    handleOpen(e) {
      this.RouteTo(e);
      localStorage.setItem('cm-route-key', e);
    },
  },
};
</script>

  <style lang="less">
  </style>
